import React from 'react'

function IndustriesIntroStrip() {
    return (
        <section className="industries-intro td-section rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10 col-lg-11">
                        <div className="industries-intro__inner">
                            <h2 className="industries-intro__title">
                                Some Companies Work With One Industry. We Work With Any Industry That Demands Excellence.
                            </h2>
                            <div className="industries-intro__text">
                                <p>
                                    There&apos;s no industry that doesn&apos;t need protecting. No business that doesn&apos;t
                                    benefit from looking like the expert in the room. No organization is immune to
                                    operational inefficiency.
                                </p>
                                <p>
                                    TechDigit Solutions started in healthcare because we saw the biggest gap between what
                                    was promised and what was actually delivered. But the skills we built—precision
                                    operations, enterprise security, and content that genuinely builds authority—translate
                                    far beyond hospital corridors.
                                </p>
                                <p className="industries-intro__emphasis">
                                    If your industry is on this page, we have specific experience that&apos;s immediately
                                    relevant to you. And if it isn&apos;t? Keep reading to the end.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default IndustriesIntroStrip
